import { LAB_CATEGORY_ORDER } from '../../makeup-flux-lab/utils/labMakeupSchema';
import {
  buildEffectiveMakeupLab,
  hydrateCustomLabFromResolved,
  resolveMakeupLabForSkin,
  studioFoundationHex,
} from '../../makeup-flux-lab/utils/makeupLabResolve';

export function labNeedsStudioResolve(lab) {
  if (!lab || typeof lab !== 'object') return false;
  return LAB_CATEGORY_ORDER.some((cat) => {
    const layer = lab[cat];
    if (!layer || typeof layer !== 'object') return false;
    return (
      layer.autoSkin ||
      layer.autoSkinConcealer ||
      layer.autoBlush ||
      layer.autoLip ||
      layer.autoEyeshadow ||
      (cat === 'concealer' && layer.autoSkin)
    );
  });
}

/** Lab sent to FLUX after Gemma foundation + studio resolve for auto cheek/lip/eye slots. */
export function prepareMakeupLabForGenerate(makeupLab, skinTone, studioResolvedLab) {
  const merged = buildEffectiveMakeupLab(makeupLab, studioResolvedLab, skinTone);
  return resolveMakeupLabForSkin(merged, skinTone);
}

export function hydrateLabFromSkinResolve(customLab, studioResolvedLab, skinTone) {
  if (!skinTone?.success || !labNeedsStudioResolve(customLab)) return customLab;
  return hydrateCustomLabFromResolved(customLab, studioResolvedLab, skinTone);
}

/** True when foundation/concealer still use Auto flags (not yet matched to guest). */
export function labHasUnresolvedAutoSkin(lab) {
  if (!lab || typeof lab !== 'object') return false;
  const f = lab.foundation;
  const c = lab.concealer;
  return Boolean(
    (f && f.autoSkin) || (c && (c.autoSkinConcealer || c.autoSkin)),
  );
}

export function formatSkinAnalysisHint(skinTone) {
  if (!skinTone?.success) return '';
  const depth = skinTone.skin_profile?.depth || skinTone.skin_depth;
  const hx = studioFoundationHex(skinTone);
  const parts = [];
  if (depth) parts.push(String(depth).replace(/_/g, ' '));
  if (hx) parts.push(`foundation ${hx}`);
  return parts.join(' · ');
}

export function missingSkinAnalysisForLab(makeupLab, skinTone) {
  if (!labNeedsStudioResolve(makeupLab)) return false;
  return !skinTone?.success;
}
